import DotLoader from "@aptedge/lib-ui/src/components/DotLoader/DotLoader";
import Box from "@mui/material/Box";
import React, { ReactElement, Suspense, lazy } from "react";
import { Route, Routes as RRRoutes } from "react-router-dom";
import { PrivateRoute } from "./PrivateRoute";
import { Routes } from "./routes";

const fullPageSuspenseFallback = (
  <Box
    height="100vh"
    width="100vw"
    display="flex"
    justifyContent="center"
    alignItems="center"
  >
    <DotLoader />
  </Box>
);

const PrivateAppRoutes = lazy(() =>
  import("./PrivateAppRoutes").then((m) => ({ default: m.PrivateAppRoutes }))
);

const LoginPage = lazy(async () => ({
  default: (await import("../pages/LoginPage/LoginPage")).LoginPage
}));

const LogoutPage = lazy(async () => ({
  default: (await import("../pages/LoginPage/LogoutPage")).LogoutPage
}));

const LoginRecoveryPage = lazy(async () => ({
  default: (await import("../pages/LoginRecoveryPage/LoginRecoveryPage"))
    .LoginRecoveryPage
}));

const LoginResetPage = lazy(async () => ({
  default: (await import("../pages/LoginResetPage/LoginResetPage"))
    .LoginResetPage
}));

const MSOAuth = lazy(
  () =>
    import("../pages/GlobalOAuth/GlobalOAuth") as Promise<{
      default: React.ComponentType;
    }>
);

const AppRoutes = (): ReactElement => {
  return (
    <Suspense fallback={fullPageSuspenseFallback}>
      <RRRoutes>
        <Route path={Routes.LOGIN} element={<LoginPage />} />
        <Route path={Routes.LOGOUT} element={<LogoutPage />} />
        <Route path={Routes.RECOVERY} element={<LoginRecoveryPage />} />
        <Route path={Routes.RESET} element={<LoginResetPage />} />
        <Route path={Routes.GLOBAL_OAUTH} element={<MSOAuth />} />

        <Route
          path="*"
          element={
            <PrivateRoute>
              <Suspense fallback={fullPageSuspenseFallback}>
                <PrivateAppRoutes />
              </Suspense>
            </PrivateRoute>
          }
        />
      </RRRoutes>
    </Suspense>
  );
};

export { AppRoutes };
